import { render, staticRenderFns } from "./portalActivity.vue?vue&type=template&id=cf8f93fc&"
import script from "./portalActivity.vue?vue&type=script&lang=js&"
export * from "./portalActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports